import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBulkDropdownData, getDropdownData } from "../../api/keyvalue";
import { AlertCircle, Package, Search } from "react-feather";
import { FORMS, MODULES } from "../../const";
import Button from "../../components/input/Button";
import LoadingSpinner from "../../components/LoadingSpinner";
import Dropdown from "../../components/input/Dropdown";
import { Select } from "semantic-ui-react";
import Grid from "../../components/Grid";
import {
  ActiveCellStyle,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";
import SideDrawer from "../../components/input/SideDrawer";
import Tab from "../../components/Tab";
import TrailersAddComponent from "../../components/master/TrailersAddComponent";
import {
  addTrailerData,
  searchTrailers,
  updateTrailerData,
  getTrailerDataById,
} from "../../api/TrailerRequest";
import { errorActions } from "../../store/error-slice";
import { toast } from "react-toastify";
import { tyreDropdown } from "../../api/tyreApi";
import { trailerTypeDropdown } from "../../api/trailerTypeApi";
import Modal from "../../components/Modal";
import { current } from "immer";

const FORM = FORMS.TRAILERS.TRL.form;

const Trailers = () => {
  const { firstViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Master,
    section: FORMS.TRAILERS,
  });

  const [tab, setTab] = useState(1);
  const [drawerTab, setDrawerTab] = useState(1);
  const [status, setStatus] = useState(null);
  const [active, setActive] = useState(null);
  const dispatch = useDispatch();
  const errorState = useSelector((state) => state.error.trailersMaterErrors);
  const [editMode, setEditMode] = useState(false);
  const [searchFetchLoading, setSearchFetchLoading] = useState(false);
  const [formData, setFormData] = useState({
    code: null,
    type: null,
    status: null,
    active: null,
    fromDate: null,
    toDate: null,
  });

  const deleteWarningRef = useRef();
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [pendingSubmitEvent, setPendingSubmitEvent] = useState(null);

  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const [searchRes, setSearchRes] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [editTrailer, setEditTrailer] = useState({});
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  // dropdown
  const [currentErrors, setCurrentErrors] = useState({});
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [trailerStatusOpt, setTrailerStatusOpt] = useState([]);
  const [trailerActiveOpt, setTrailerActiveOpt] = useState([]);
  const [tyreSizeOpt, setTyreSizeOpt] = useState([]);
  const [trailTypesOpt, setTrailTypeOpt] = useState([]);

  const trailerRef = useRef();

  const trailerCodeRef = useRef(null);
  const trailerNumberRef = useRef(null);
  const trailerTypeRef = useRef(null);
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");

  const user = useSelector((state) => state.user);

  const [initialActive, setInitialActive] = useState(1);

useEffect(() => {
  if (editMode && editTrailer) {
    setInitialActive(editTrailer.trlActive);
  }
}, [editMode, editTrailer]);

useEffect(() => {
  if (editMode && editTrailer) {
    setInitialActive(editTrailer.trlActive);
  }
}, [editMode, editTrailer]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      //new

      const { active, status } = await getBulkDropdownData([
        { key: "active" },
        { key: "status" },
      ]);

      setActiveOptions(active);
      setTrailerActiveOpt(active);
      setStatusOptions(status);
      setTrailerStatusOpt(status);

      const tyreData = await tyreDropdown();
      setTyreSizeOpt(tyreData);

      const trailerTypeData = await trailerTypeDropdown();
      setTrailTypeOpt(trailerTypeData);

      setIsLoading(false);
    })();
  }, []);

  const handleDrawerOpen = () => {
    setIsLoading(false);
    setIsDrawerOpen(true);
    setEditMode(false);
    setEditTrailer(null);
    setDrawerTab(1);
  };
  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const reset = () => {
    trailerRef.current.resetForm();

    setEditMode(false);
    setEditTrailer(null);
  };

  // const handleSubmit = async (e, bypassDeleteCheck) => {
  //   e.preventDefault();
  //   const data = trailerRef.current.getData();

  //   const isDeletedActive = data.trlActive === 2 && initialActive !== 2;

  //   if (!bypassDeleteCheck && trailerRef.current.isDeletedActive()) {
  //     setPendingSubmitEvent(e);
  //     setShowDeleteWarning(true);
  //     deleteWarningRef.current?.showModal();
  //     return;
  //   }
  //   setSubmitted(true);
  //   setIsSubmitLoading(true);
  //   dispatch(errorActions.clearTrailersError());

  //   const trailersErrors = trailerRef.current.validateForm();
  //   if (Object.keys(trailersErrors).length > 0) {
  //     dispatch(
  //       errorActions.validateTrailers({
  //         trailerRequest: trailerRef.current.getData(),
  //       }),
  //     );
  //     setIsSubmitLoading(false);
  //     toast.error("There was an error adding Trailers", {
  //       autoClose: 5000,
  //       containerId: "Main",
  //     });
  //   } else {
  //     if (editMode) {
  //       await updateTrailerData({
  //         // trailerRequest: trailerRef.current.getData(),
  //         trlId: trailerRef.current.getData().trlId,
  //         trlReference: trailerRef.current.getData().trlReference,
  //         trlTrailerNo: trailerRef.current.getData().trlTrailerNo,
  //         trlTransporter: trailerRef.current.getData().trlTransporter,
  //         trlTrailerType: trailerRef.current.getData().trlTrailerType,
  //         trlDescription: trailerRef.current.getData().trlDescription,
  //         trlStatus: trailerRef.current.getData().trlStatus,
  //         trlActive: trailerRef.current.getData().trlActive,
  //         createdBy: trailerRef.current.getData().createdBy,
  //         createdDate: trailerRef.current.getData().createdDate,
  //         lastModifiedBy: trailerRef.current.getData().lastModifiedBy,
  //         lastModifiedDate: trailerRef.current.getData().lastModifiedDate,
  //         trlChassisNo: trailerRef.current.getData().trlChassisNo,
  //         trlTyres: trailerRef.current.getData().trlTyres,
  //         trlYearManufacture: trailerRef.current.getData().trlYearManufacture,
  //         trlInsuranceExpiry: trailerRef.current.getData().trlInsuranceExpiry,
  //         trlDefaultTruck: trailerRef.current.getData().trlDefaultTruck,
  //         trlCompany: trailerRef.current.getData().trlCompany,
  //         author: user.username,
  //       });
  //       toast.success("Trailer update successfully!", {
  //         autoClose: 5000,
  //         containerId: "Main",
  //       });
  //     } else {
  //       await addTrailerData({
  //         // trailerRequest: trailerRef.current.getData(),
  //         trlCode: "",
  //         trlReference: trailerRef.current.getData().trlReference,
  //         trlTrailerNo: trailerRef.current.getData().trlTrailerNo,
  //         trlTransporter: trailerRef.current.getData().trlTransporter,
  //         trlTrailerType: trailerRef.current.getData().trlTrailerType,
  //         trlDescription: trailerRef.current.getData().trlDescription,
  //         trlStatus: trailerRef.current.getData().trlStatus,
  //         trlActive: trailerRef.current.getData().trlActive,
  //         createdBy: trailerRef.current.getData().createdBy,
  //         createdDate: trailerRef.current.getData().createdDate,
  //         lastModifiedBy: trailerRef.current.getData().lastModifiedBy,
  //         lastModifiedDate: trailerRef.current.getData().lastModifiedDate,
  //         trlChassisNo: trailerRef.current.getData().trlChassisNo,
  //         trlTyres: trailerRef.current.getData().trlTyres,
  //         trlYearManufacture: trailerRef.current.getData().trlYearManufacture,
  //         trlInsuranceExpiry: trailerRef.current.getData().trlInsuranceExpiry,
  //         trlDefaultTruck: trailerRef.current.getData().trlDefaultTruck,
  //         trlCompany: trailerRef.current.getData().trlCompany,
  //         author: user.username,
  //       });
  //       toast.success("Trailer added successfully!", {
  //         autoClose: 5000,
  //         containerId: "Main",
  //       });
  //     }
  //     handleDrawerClose();
  //     setIsSubmitLoading(false);
  //     reset();
  //   }
  // };
const handleSubmit = async (e, bypassDeleteCheck) => {
  e.preventDefault();

  const data = trailerRef.current.getData();

  const isDeletedActive =
    Number(data.trlActive) === 2 && Number(initialActive) !== 2;

  if (!bypassDeleteCheck && isDeletedActive) {
    setPendingSubmitEvent(e);
    setShowDeleteWarning(true);
    deleteWarningRef.current?.showModal();
    return;
  }

  setSubmitted(true);
  setIsSubmitLoading(true);
  dispatch(errorActions.clearTrailersError());

  const trailersErrors = trailerRef.current.validateForm();

  if (Object.keys(trailersErrors).length > 0) {
    dispatch(
      errorActions.validateTrailers({
        trailerRequest: data,
      })
    );

    setIsSubmitLoading(false);

    toast.error("There was an error adding Trailers", {
      autoClose: 5000,
      containerId: "Main",
    });
  } else {
    try {
      if (editMode) {
        await updateTrailerData({
          ...data,
          author: user.username,
        });

        toast.success("Trailer updated successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        await addTrailerData({
          trlCode: "",
          ...data,
          author: user.username,
        });

        toast.success("Trailer added successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });
      }

      handleDrawerClose();
      reset();
    } catch (err) {
      toast.error("Something went wrong!", {
        autoClose: 5000,
        containerId: "Main",
      });
    } finally {
      setIsSubmitLoading(false);
    }
  }
};
  const handleSearchSubmit = async (e) => {
    e.preventDefault();

    if (tab === 1) {
      setIsLoading(false);
      setActiveAccordion1(false);
      setResetVisible(true);
      setSearchClicked(true);
      setSearchSubmitLoading(true);
    }
    const response = await searchTrailers({
      trlCode: trailerCodeRef.current.value,
      trlTrailerNo: trailerNumberRef.current.value,
      trlTrailerType: trailerTypeRef.current.value,
      toDate: toDate,
      fromDate: fromDate,
      trlStatus: status,
      trlActive: active,
    });
    setSearchRes(response);
    setSearchSubmitLoading(false);
  };

  const handleSearchReset = (e) => {
    e.preventDefault();
    trailerCodeRef.current.value = "";
    trailerNumberRef.current.value = "";
    trailerTypeRef.current.value = null;
    setStatus("");
    setActive("");
    setFromDate(null);
    setToDate(null);
    setFormData({
      type: null,
      fromDate: null,
      toDate: null,
    });
  };

  const deleteWarningModal = (
    <div style={{ padding: "20px" }}>
      <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <AlertCircle color="red" size="25" />
        <p>Warning</p>
      </h3>
      <p>Active is set to Deleted. Are you sure you want to proceed?</p>
      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <Button
          label="Cancel"
          onClick={() => {
            deleteWarningRef.current?.close();
            setShowDeleteWarning(false);
            setPendingSubmitEvent(null);
          }}
        />
        <Button
          label="Proceed"
          className="ui red button"
          onClick={() => {
            deleteWarningRef.current?.close();
            setShowDeleteWarning(false);
            handleSubmit(pendingSubmitEvent, true);
            setPendingSubmitEvent(null);
          }}
        />
      </div>
    </div>
  );

  return (
    <>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        <div className="ui tabular menu attached">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <Package size={15} style={{ marginRight: "5px" }} />
            </span>
            Trailers Search
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "0px",
          }}
          className="ui tabular menu top attached"
        >
          <Button
            template="drawerOpen"
            onClick={handleDrawerOpen}
            authenticated={true}
            form={FORMS.TRAILERS.TRL.form}
            module={MODULES.Master}
            disabled={firstViableTab === -1}
            editMode={false}
          />
        </div>
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {}}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui diving header">Trailers Information</h4>
                <div className="three fields">
                  <div className="field">
                    <label>Trailer Code</label>
                    <input
                      type="text"
                      placeholder="Trailer Code"
                      name="trlCode"
                      ref={trailerCodeRef}
                    />
                  </div>

                  <div className="field">
                    <label>Trailer Number</label>
                    <input
                      type="text"
                      placeholder="Trailer Number"
                      name="trlTrailerNo"
                      ref={trailerNumberRef}
                    />
                  </div>

                  <Dropdown
                    label="Trailer Type"
                    error={currentErrors.type}
                    module={MODULES.Master}
                    form={FORM}
                    field="trl_trailor_type"
                    editMode={editMode}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { type: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                    clearable
                    placeholder="Trailer Type"
                    style={{ height: "5px" }}
                    ref={trailerTypeRef}
                    options={trailTypesOpt}
                    value={formData.type}
                    onChange={(e, data) => {
                      setFormData({
                        ...formData,
                        type: data.value,
                      });
                    }}
                  />
                </div>
                <div className="four fields">
                  <div className="field">
                    <label>From Date</label>
                    <input
                      type="date"
                      name="trailerToDate"
                      placeholder="To Date"
                      value={fromDate}
                      onChange={(e) => {
                        setFromDate(e.target.value);
                      }}
                    />
                  </div>
                  <div className="field">
                    <label>To Date</label>
                    <input
                      type="date"
                      name="trailerFromDate"
                      placeholder="To Date"
                      value={toDate}
                      onChange={(e) => {
                        setToDate(e.target.value);
                      }}
                    />
                  </div>
                  <div className="field">
                    <label>Status</label>
                    <Select
                      options={statusOptions}
                      placeholder="Status"
                      style={{ height: "20px" }}
                      value={status}
                      onChange={(e, data) => {
                        setStatus(data.value);
                      }}
                    />
                  </div>
                  <div className="field">
                    <label>Active</label>
                    <Select
                      options={activeOptions}
                      placeholder="Active"
                      style={{ height: "20px" }}
                      value={active}
                      onChange={(e, data) => {
                        setActive(data.value);
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={searchFetchLoading}
                content={searchRes}
                config={[
                  {
                    headerName: "Id",
                    field: "trl_id",
                    sort: "desc",
                    hide: true,
                  },
                  {
                    headerName: "Trailer Code",
                    field: "trlCode",
                  },
                  {
                    headerName: "Trailer Number",
                    field: "trlTrailerNo",
                  },
                  {
                    headerName: "Trailer Type",
                    field: "ttyType",
                  },
                  {
                    headerName: "Status",
                    field: "trlStatus",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "trlActive",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await getTrailerDataById(props.data.trl_id);
                  setEditTrailer(response);
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  setSearchFetchLoading(false);
                }}
              />
            )}
          </>
        )}
      </div>

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          editMode ? (
            <>
              <div
                className="trailer-code-header"
                style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
              >
                <h3>
                  Trailer Code:
                  {editTrailer?.trlCode}
                </h3>
              </div>
            </>
          ) : null
        }
        body={
          <>
            <form className="drawer-content" onSubmit={handleSubmit}>
              <div style={{ width: "60vw", boxShadow: "none" }}>
                <div className="ui top attached tabular menu">
                  <Tab
                    Icon={Package}
                    onClick={() => {
                      setDrawerTab(1);
                    }}
                    active={drawerTab === 1}
                    errors={
                      Object.keys(errorState.trailersMaterErrors).length !== 0
                    }
                    label="Trailers"
                    authenticated={true}
                    form={FORMS.TRAILERS.TRL_DETAIL.form}
                    showMandatory={true}
                    isMandatory={true}
                  />
                </div>
                <div
                  className="ui bottom attached active tab segment"
                  style={{ display: drawerTab === 1 ? "block" : "none" }}
                >
                  <TrailersAddComponent
                    ref={trailerRef}
                    isLoading={isLoading}
                    errors={errorState.trailersMaterErrors}
                    dropdown={{
                      trailerStatusOpt,
                      trailerActiveOpt,
                      tyreSizeOpt,
                      trailTypesOpt,
                    }}
                    editMode={editMode}
                    currentValues={editMode ? editTrailer : null}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {editMode ? (
                      <Button
                        type="submit"
                        template="create"
                        isLoading={isSubmitLoading}
                        create={!editMode}
                        form={FORMS.TRAILERS.TRL.form}
                        module={MODULES.Master}
                        section={FORMS.TRAILERS}
                        authenticated={true}
                        editMode={editMode}
                      />
                    ) : drawerTab === 1 && !isLoading ? (
                      <Button
                        type="submit"
                        template="create"
                        isLoading={isSubmitLoading}
                        create={!editMode}
                        form={FORMS.TRAILERS.TRL.form}
                        module={MODULES.Master}
                        section={FORMS.TRAILERS}
                        authenticated={true}
                        editMode={editMode}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </form>
            <Modal
              ref={deleteWarningRef}
              closeButton={false}
              minWidth={"300px"}
            >
              {showDeleteWarning && deleteWarningModal}
            </Modal>
          </>
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />
    </>
  );
};

export default Trailers;
